module.exports = __webpack_public_path__ + "img/bar-chart.9b0d5715.svg";